import React from 'react';

import {
  Avatar as MuiAvatar,
  AvatarProps as MuiAvatarProps,
  AvatarGroup as MuiAvatarGroup,
  AvatarGroupProps as MuiAvatarGroupProps,
  SxProps,
  Theme
} from '@mui/material';

import palette from '../theme/palette';

export type AvatarStyle = {
  color: string;
  backgroundColor: string;
};

const avatarStyles: AvatarStyle[] = [
  {
    color: palette.white,
    backgroundColor: palette.grey[1400]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1500]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1600]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1700]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1800]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[1900]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[2000]
  },
  {
    color: palette.white,
    backgroundColor: palette.grey[2100]
  }
];
const hashString = (str: string): number => {
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
};

const getAvatarStyle = (id?: string): Partial<AvatarStyle> => {
  if (!id || typeof id !== 'string') return {};
  if (id.trim() === '') return {};

  const index = hashString(id) % avatarStyles.length;
  return avatarStyles[index];
};

interface AvatarProps extends MuiAvatarProps {
  id?: string;
}

export const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ id, children, sx, ...props }, ref) => {
    const { color, backgroundColor } = getAvatarStyle(id);
    return (
      <MuiAvatar
        ref={ref}
        sx={{
          color,
          backgroundColor: backgroundColor || palette.globalBackground,
          ...sx
        }}
        {...props}
      >
        {children}
      </MuiAvatar>
    );
  }
);

interface AvatarGroupProps extends MuiAvatarGroupProps {
  sx?: SxProps<Theme> & {
    borderColor?: string;
    height?: string | number;
    width?: string | number;
    fontSize?: string | number;
  };
}

export const AvatarGroup = React.forwardRef<HTMLDivElement, AvatarGroupProps>(
  ({ children, sx, ...props }, ref) => {
    return (
      <MuiAvatarGroup
        ref={ref}
        {...props}
        sx={{
          '& .MuiAvatar-root': {
            border: `1px solid ${sx?.borderColor || palette.globalBackground}`,
            height: sx?.height || '24px',
            width: sx?.width || '24px',
            fontSize: sx?.fontSize || '10px'
          },
          ...sx
        }}
      >
        {children}
      </MuiAvatarGroup>
    );
  }
);
